var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("carpass")))]),
                      _vm.hasCarpass
                        ? [
                            _c(
                              "w-card-content",
                              [
                                _c(
                                  "w-row",
                                  [
                                    _c(
                                      "w-col",
                                      [
                                        _c("w-input", {
                                          attrs: {
                                            fancy: "",
                                            label: _vm.$ct("username"),
                                          },
                                          model: {
                                            value: _vm.carpassConfig.Username,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.carpassConfig,
                                                "Username",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "carpassConfig.Username",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-row",
                                  [
                                    _c(
                                      "w-col",
                                      [
                                        _c("w-input", {
                                          attrs: {
                                            password: "",
                                            fancy: "",
                                            label: _vm.$ct("password"),
                                          },
                                          model: {
                                            value: _vm.carpassConfig.Password,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.carpassConfig,
                                                "Password",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "carpassConfig.Password",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-row",
                                  [
                                    _c(
                                      "w-col",
                                      [
                                        _c("w-input", {
                                          attrs: {
                                            "has-error": !_vm.isKboNumberValid,
                                            fancy: "",
                                            label: _vm.$ct("kbo-number"),
                                          },
                                          on: {
                                            blur: function ($event) {
                                              _vm.kboBlured = true
                                            },
                                          },
                                          model: {
                                            value: _vm.carpassConfig.KboNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.carpassConfig,
                                                "KboNumber",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "carpassConfig.KboNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "w-card-actions",
                              [
                                _c("w-spacer"),
                                _c(
                                  "w-button",
                                  {
                                    attrs: {
                                      disabled: _vm.saveDisabled,
                                      icon: "save",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveCarpass()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$ct("test-and-save")))]
                                ),
                              ],
                              1
                            ),
                          ]
                        : _c("app-missing-module", {
                            attrs: { "module-id": _vm.carpassModule },
                          }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }